export interface AiResearchContextType {
    contextType: string;
    contextId: number;
}

export enum AiContextTypes {
    LOCATION = 'location',
}

export enum AiAgentTypes {
    EDISON = 'edison',
    RESEARCH = 'research',
}
